module.exports = __webpack_public_path__ + "static/flairboat-6775f8ba083472e849f52a3af4a9f32c.png";